export default __webpack_public_path__ + "static/media/login.8689a139.png";